<template>
<div :id="'upload-'+path" v-if="show">
	<script type="text/template" :id="'uploadtemplate-'+path">

		<div style="margin-bottom:5px">
			<div class="row"> 
        		<span class="name col-sm-3" data-dz-name></span>
 				<div class="col-sm-6">
        			<p class="size" data-dz-size></p>
        			<div class="progress progress-striped active" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
          				<div class="progress-bar progress-bar-success" style="width:0%;" data-dz-uploadprogress></div>
        			</div>
				</div>
				<div class="col-sm-3">
            		<button data-dz-remove class="btn btn-danger btn-sm cancel">
            			<i class="glyphicon glyphicon-minus"></i> {{$t('inputUpload.delete')}}
            		</button>
            		<span class="text-success success" style="display:none">
            			{{$t('inputUpload.success')}} <i class="glyphicon glyphicon-ok"></i>
            		</span>
            		<span class="text-danger error" style="display:none">
            			{{$t('inputUpload.fail')}} <i class="glyphicon glyphicon-warning-sign"></i>
            		</span>
				</div>
			</div>

        </div>
    </script>


	<div class="form-group">
		<label class="control-label col-md-3">{{$t('orderEdit.upload.category.'+path)}}</label>
		<div class="col-md-9">
			<div class="form-control-static">
				<a data-toggle="collapse" :data-target="'#collapse-'+path"> <i
					class="glyphicon glyphicon-arrow-down"></i>
					{{$t('inputUpload.fileUpload')}}
				</a> <a @click="openModal"> <span
					class="glyphicon glyphicon-list-alt"></span>
					{{$t('inputUpload.history')}}
				</a> | <strong>Counter: {{counter}}</strong>
			</div>

		</div>
	</div>
	
	<div :id="'uploadModal-'+path" class="modal fade">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal"
						aria-hidden="true">&times;</button>
					<h4 class="modal-title">{{$t('inputUpload.history')}}:
						{{$t('orderEdit.upload.category.'+path)}}</h4>
				</div>
				<div class="modal-body">
				
					<server-status :status="server_status"/>

					<table v-if="server_status === this.$cons.STATUS.DATA" class="table table-striped table-bordered table-condensed">
						<thead>
							<tr>
								<th>{{$t('inputUpload.file')}}</th>
								<th>{{$t('inputUpload.user')}}</th>
								<th>{{$t('inputUpload.time')}}</th>
								<th>Aktion</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(upload, index) in data">
								<td><a :href="'order/order/downloadFile/?order='+ $route.params.id + '&file=' + upload.id">{{upload.filename}} </a></td>
								<td>{{upload.uploader}}</td>
								<td>{{upload.datetime}}</td>
								<td><template v-if="canDelete">
									 <a @click="deleteUpload(index)">
									 <span class="glyphicon glyphicon-remove" style="color: red"></span>
										Datei löschen</a> </template>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">{{$t('misc.close')}}</button>
				</div>
			</div>
		</div>
	</div>
			
	<div :id="'collapse-'+path" class="collapse" style="margin-top: 10px">
		<div>
			<button class="btn btn-success">
				<i class="glyphicon glyphicon-plus"></i>
				{{$t('inputUpload.select')}}
			</button>
			<button class="btn button_tiefox_dark" @click="send">
				<i class="glyphicon glyphicon-upload"></i>
				{{$t('inputUpload.upload')}}
			</button>
		</div>

		<div style="margin-top: 5px">
			<div class="panel panel-info">
				<div class="panel-heading text-center">
					<h4>{{$t('inputUpload.pull')}}</h4>
				</div>
				<div id="files" class="panel-body"></div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import Dropzone from "dropzone"
import {capitalizeFirstLetter} from '@/javascript/misc.js'

export default {
  name: "UploadInput",
  data() {
    return {
    	myDropzone: null,
    	data: {},
    	counter: 0,
    	show: this.$auth.hasPermission('upload'+capitalizeFirstLetter(this.path)),
    	canDelete: this.$auth.hasPermission('deleteUpload'+capitalizeFirstLetter(this.path)),
    	server_status: this.$cons.STATUS.LOADING
    };
  },
  props: ["path", "set", "value"],
  
  mounted() {
	  if(this.show) {
		this.createDropzone();
	  }
  },
  
  created() {
	  if(this.show) {
		this.$eventBus.$on("refresh-page", this.getCounter);
		this.getCounter();
	  }
  },
	  
  beforeDestroy(){
	  if(this.show) {
    	this.$eventBus.$off("refresh-page", this.getCounter);
	  }
  },
      
  methods: {  	  
	  openModal() {
		  this.$globals.getData(this, "order/order/uploadHistory/?order="+this.$route.params.id+"&path="+this.path);
		  $("#uploadModal-"+this.path).modal('show');
	  },
		
	  getCounter() {
		    axios
		      .get("order/order/uploadHistoryCounter/?order="+this.$route.params.id+"&path="+this.path)
		      .then(response => {
		        this.counter = response.data.counter;
		      })
	  },  
			  
	  createDropzone() {
	  	var path = this.path;
        var preview = $('#uploadtemplate-' + path).html();
        this.myDropzone =  new Dropzone('#upload-'+ path + " .panel",{ 
	       url: this.set,
	       maxFilesize: 5000,
	       createImageThumbnails: false,
	       parallelUploads : 50,
	       previewTemplate : preview,
	       previewsContainer: '#upload-' + path + " .panel-body",
	       //autoQueue : false, 
	       clickable : '#upload-'+ path + " .btn-success",
	       headers: {
	           'xsrf-token': this.$auth.getCookieValue('xsrf-token')
	       },
           success: function(file, response){
    	       file.previewElement.querySelector('.cancel').style.display='none';
               if(response == 'success') {
    	           file.previewElement.querySelector('.success').style.display='inline';
    	           this.counter++;
               } else {
                   file.previewElement.querySelector('.error').style.display='inline';
               }
           },
           error: (file, error, xhr) => {
        	  console.log(error);
        	  bootbox.alert("<b>"+this.$t('misc.errorOccured')+"</b>") 
           }
        });
        this.myDropzone.on('sending', function(file, xhr, formData) {
            formData.append('path', path);
        });
	  },
	  
	  deleteUpload(index) {
		  if(this.canDelete) {
		    bootbox.confirm(
	     		this.$t('clientList.deleteConfirmation', {name: this.data[index].filename}), 
	 	   		result => { 
	 	   			if(result === true) {
	 			   	 axios
	 			        .post("order/order/deleteUploadedFile/?order="+this.$route.params.id+"&file="+this.data[index].id)
	 			        .then(response => {
	 			        	if(response.data.status) {
	 			        		this.data.splice(index,1);
	 			        	} 
	 			        });
	 	   			}
	 	   		}	
	     	);
	     }
	  },
	  
	  send() {
		  this.myDropzone.enqueueFiles(this.myDropzone.getFilesWithStatus(Dropzone.ADDED));
	  }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/input/FileUploadInput.vue